// ===============================
// 🔥 INIT FUNCTION (uniwersalna)
// ===============================
function initAutocomplete({inputSelector, boxSelector, variant = 'full'}) {

    const input = document.querySelector(inputSelector);
    const box = document.querySelector(boxSelector);

    if (!input || !box) return;

    let debounceTimer = null;
    let controller = null;

    let selectedIndex = -1;
    let currentItems = [];
    const cache = new Map();

    // ===============================
    // 🧹 CLEAR
    // ===============================
    function clearSuggestions() {
        box.innerHTML = '';
        box.classList.remove('show');
        selectedIndex = -1;
        currentItems = [];
    }

    // ===============================
    // ⏳ LOADING
    // ===============================
    function showLoading() {
        box.classList.add('show');
        box.innerHTML = `
<div class="suggestion loading">
    <div class="spinner"></div>
<span>Szukam...</span>
</div>
`;
    }

    // ===============================
    // 🖼️ RENDER
    // ===============================
    function renderSuggestions(items) {
        if (!items.length) {
            clearSuggestions();
            return;
        }

        currentItems = items;
        selectedIndex = -1;

        box.classList.add('show');
        box.innerHTML = '';

        items.forEach((item, index) => {
            const el = document.createElement('a');
            el.className = 'suggestion';
            el.href = item.url;
            el.setAttribute('tabindex', '0');

            el.innerHTML = `
<div class="image">
    <img src="${item.image}" alt="${item.name}" loading="lazy">
    </div>
<div class="content">
    <div class="title">${item.name}</div>
    <div class="code">${item.code ?? ''}</div>
</div>
    `;

            // 🔥 log kliknięcia
            el.addEventListener('click', () => {
                try {
                    navigator.sendBeacon('/search/click', JSON.stringify({
                        term: input.value,
                        product_id: item.id,
                        position: index
                    }));
                } catch (e) {
                }
            });

            box.appendChild(el);
        });

        // 🔥 footer (opcjonalny)
        const more = document.createElement('a');
        more.className = 'suggestion more';
        more.href = `/szukaj?q=${encodeURIComponent(input.value)}`;
        more.innerHTML = `
            <span>Zobacz wszystkie wyniki</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <circle cx="11" cy="11" r="8"></circle>
                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
            </svg>
        `;

        box.appendChild(more);
    }

    // ===============================
    // 🌐 FETCH
    // ===============================
    async function fetchSuggestions(term) {
        if (cache.has(term)) {
            renderSuggestions(cache.get(term));
            return;
        }

        if (controller) controller.abort();
        controller = new AbortController();

        showLoading();

        try {
            const res = await fetch(`/szukaj/autocomplete?term=${encodeURIComponent(term)}&variant=${variant}`, {
                signal: controller.signal,
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                }
            });

            if (!res.ok) throw new Error('Request failed');

            const data = await res.json();

            cache.set(term, data);
            renderSuggestions(data);

        } catch (e) {
            if (e.name !== 'AbortError') {
                clearSuggestions();
            }
        }
    }

    // ===============================
    // ⌨️ INPUT
    // ===============================
    let lastTerm = '';

    input.addEventListener('input', function () {
        const term = this.value.trim();

        clearTimeout(debounceTimer);

        if (term.length < 3) {
            clearSuggestions();
            return;
        }

        debounceTimer = setTimeout(() => {

            if (term === lastTerm) {
                return;
            }

            lastTerm = term;
            fetchSuggestions(term);

        }, 400);
    });

    // ===============================
    // ⬇️ KEYBOARD
    // ===============================
    input.addEventListener('keydown', (e) => {
        const items = box.querySelectorAll('.suggestion');

        if (!items.length) return;

        if (e.key === 'ArrowDown') {
            e.preventDefault();
            selectedIndex = (selectedIndex + 1) % items.length;
        }

        if (e.key === 'ArrowUp') {
            e.preventDefault();
            selectedIndex = (selectedIndex - 1 + items.length) % items.length;
        }

        if (e.key === 'Enter') {
            if (selectedIndex >= 0 && currentItems[selectedIndex]) {
                e.preventDefault();
                window.location.href = currentItems[selectedIndex].url;
            }
        }

        items.forEach((el, index) => {
            el.classList.toggle('active', index === selectedIndex);

            if (index === selectedIndex) {
                el.scrollIntoView({block: 'nearest'});
            }
        });
    });

    // ===============================
    // 🖱️ CLICK OUTSIDE
    // ===============================
    document.addEventListener('click', (e) => {
        if (!e.target.closest(inputSelector) && !e.target.closest(boxSelector)) {
            clearSuggestions();
        }
    });
}


// ===============================
// 🚀 INIT INSTANCES
// ===============================

// główna wyszukiwarka
initAutocomplete({
    inputSelector: '#site-search',
    boxSelector: '#suggestions',
    variant: 'full'
});

// header
initAutocomplete({
    inputSelector: '#mast-q',
    boxSelector: '#suggestions-header',
    variant: 'header'
});
